module.exports = __webpack_public_path__ + "img/s22.5c4902ba.png";